import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { setSelectRentalCar } from "../../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../../features/modal/modalSlice";
import { adminSatilikAracAprove } from "../../../features/admin3/admin3Slice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(10, 1fr); 
        align-items: center;
        justify-content: center;
        height: auto;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
          p{
            border: 1px solid var(--color-main);
            padding: 5px;
            border-radius: 5px;
            color: var(--color-main);
            cursor: pointer;
          }
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
  .click{
    color: var(--color-main);
    cursor: pointer;
    text-decoration: underline;
  }
`;

const AdminSatilikAraclarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
 
  const handleAprove = ({item, approve}) => {
    dispatch(adminSatilikAracAprove({id: item?.id, isApproved:approve }))
  }



  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data?.vehicleType}</div>
            <div className="col">{data?.model}</div>
            <div className="col">{data?.km}</div>
            <div className="col">{data?.price}</div>
            <div className="col">{data?.description}</div>
            <div className="col click"> <span  onClick={() => {dispatch(setSelectRentalCar(data)); dispatch(showModal("advertShowPhoto"))}}>Fotoğraflar</span> </div>
            <div className="col">{moment(data?.advertEndDate).format('L')}</div>
            {data?.isApproved === 0 && <div onClick={(e) => e.stopPropagation()}  className="col">
              <p onClick={() => handleAprove({item: data, approve: 1})}>Onayla</p>
              <p onClick={() => handleAprove({item: data, approve: 2})}>Reddet</p>
            </div> }
            {data?.isApproved === 1 && <div className="col">Onaylandı</div> }
            {data?.isApproved === 2 && <div className="col">Reddedildi</div> }
            
            <div className="col">{data?.advertStatus}</div>
            <div className="col">{data?.isVehicleRented === true ? "Evet" : "Hayır"}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminSatilikAraclarContainer;
